import { useSelector, useDispatch } from "react-redux";
import {DataGrid, gridClasses, GridToolbar} from '@mui/x-data-grid';
import {Box, Button, dividerClasses, FormControl, IconButton, InputLabel, MenuItem, Select} from "@mui/material";
import { styled } from '@mui/material/styles';
import React, {useEffect, useState} from "react";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {getCollectionById, getCollections} from "./actions/collections";
import { setCollections } from "./reducers/collections";
import {useParams} from "react-router-dom";
import {setAssetTypes} from "./reducers/asset_types";
import {getCustomers} from "./actions/customers";
import {setCustomers} from "./reducers/customers";
import {getAssetTypes} from "./actions/asset_types";
import {clearAssets, setAssets} from "./reducers/assets";
import {setStates} from "./reducers/states";
import {getStates} from "./actions/states";
import jwt_decode from "jwt-decode";
import {useCookies} from "react-cookie";
/*
import Papa from 'papaparse';
import CloseIcon from "@mui/icons-material/Close";
import * as XLSX from 'xlsx';
*/


import ExcelJS from 'exceljs';
import {EMPTY_STATS, statsFromCollection, statsByTypeName} from "./utilities/stats";
import {formatCityStateZip} from "./utilities/string";
import {displayItemNumbers, byItemNumber} from "./utilities/itemNumber";

const pageSizeOptions = [20];
const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
    [`&`]: { height: '850px' },
    [`& .${gridClasses.row}.even`]: {
        backgroundColor: '#F8F8F8'
    },
    [`& .${gridClasses.row}.selected`]: {
        backgroundColor: '#006225', // TODO make this match Compucycle branding guidelines
        color: 'white'
    },
    [`& .${gridClasses.row}.selected:hover`]: {
        backgroundColor: '#009f3c', // TODO make this match Compucycle branding guidelines
        color: 'white'
    }
}));

const CollectionReports = (props = {}) => {
    const dispatch = useDispatch();
    const { id } = useParams();
    const [ isLoaded, setIsLoaded ] = useState(false);
    const [ loading, setLoading] = useState(false);

    const collections = useSelector(state => state.collections.value);
    const customers = useSelector(state => state.customers.value);
    const assetTypes = useSelector(state => state.assetTypes.value);
    const assets = useSelector(state => state.assets.value);
    const auth = useSelector(state => state.auth.value);
    const states = useSelector(st => st.states.value );

    //const [cookies, setCookie, removeCookie] = useCookies(['access_token']);
    const [cookies] = useCookies(['access_token']);

    const [ selectedCollection, setSelectedCollection ] = useState(null);

    const [ collectionsWithRelations, setCollectionsWithRelations ] = useState([]);
    const [stats , setStats ] = useState({...EMPTY_STATS, assetsCollected: {}});
    const [dataFilter , setDataFilter ] = useState([]);

    const handleDataFilter = (props) => {

        setDataFilter({...props})
    }

    const columns = [
        {
            field: "edit-action",
            width: 50,
            headerName: "",
            sortable: false,
            renderCell: (params) => {
                const onClick = (e) => {
                    e.stopPropagation(); // don't select this row after clicking

                    return alert(`Attempted to edit ${params.row.Description} - ${params.row.SerialNumber}`);
                };

                const canEdit = [1,2,3].find(x => jwt_decode(cookies.access_token).user.role === x) || (selectedCollection != null && Date.parse(selectedCollection.start_time) > (Date.now() - 1000 * 60 * 60 * 24 * 7));
                return <IconButton variant="outlined" onClick={onClick} disabled={!canEdit}>
                    <EditIcon/>
                </IconButton>
            }
        },
        //{ field: 'id', headerName: 'ID', width: 100, editable: false},
        { field: 'serial_number', headerName: 'Serial Number', width: 150, editable: false},
        { field: 'asset_type', headerName: 'Asset Type', width: 200, editable: false, valueGetter: (params) => params.row.assetType != null ? params.row.assetType.name : ""},
        { field: 'asset_tag', headerName: 'AssetTag', width: 125, editable: false },
        { field: 'description', headerName: 'Description', width: 300, editable: false },
        { field: 'collection_notes', headerName: 'Notes', width: 300, editable: false },
        {
            field: "delete-action",
            headerName: "",
            width: 50,
            sortable: false,
            renderCell: (params) => {
                const onClick = (e) => {
                    e.stopPropagation(); // don't select this row after clicking

                    return alert(`Attempted to delete ${params.row.Description} - ${params.row.SerialNumber}`);
                };

                // can delete if user is admin, manager, or supervisor, or if the collection is less than 7 days old
                const canDelete = [1,2,3].find(x => jwt_decode(cookies.access_token).user.role === x) || (selectedCollection !== null && Date.parse(selectedCollection.start_time) > (Date.now() - 1000 * 60 * 60 * 24 * 7));
                return <IconButton variant="outlined" onClick={onClick} disabled={!canDelete}>
                    <DeleteIcon />
                </IconButton>
            }
        },
        { field: 'collected', headerName: 'Collected', width: 300, editable: false },
        { field: 'unexpected', headerName: 'Unexpected', width: 300, editable: false }
    ]

    useEffect(() => {
        const fetchData = () => async (dispatch) => {
            if( customers.length === 0 ) {
                const updatedCustomers = await getCustomers(auth.token);
                dispatch(setCustomers(updatedCustomers.data));
            }
            if( assetTypes.length === 0 ) {
                const updatedAssetTypes = await getAssetTypes(auth.token);
                dispatch(setAssetTypes(updatedAssetTypes.data));
            }
            if( collections.length === 0 ) {
                const updatedCollections = await getCollections(auth.token);
                dispatch(setCollections(updatedCollections.data));
            }
            if( states.length === 0 ) {
                const updatedStates = await getStates();
                dispatch(setStates(updatedStates.data));
            }
            setIsLoaded(true);
        }
        dispatch(fetchData());
    }, [dispatch,assetTypes,auth,collections,customers,states] );

    useEffect(() => {
        setCollectionsWithRelations(isLoaded ? collections
            .map( collection => {
                const cust = customers.find( customer => customer.id === collection.customer_id) || { };
                return Object.assign({}, collection, {
                    customer: cust,
                    state: states.find(s => s.id === cust.state_id)
                })
            })
            .sort((a,b) => {
                if (a.customer.customer_name !== b.customer.customer_name) {
                    // customer_name is missing whenever cust fell back to {} above.
                    return (a.customer.customer_name || '').localeCompare(b.customer.customer_name || '')
                }
                if (a.LotNumber !== b.LotNumber) {
                    return parseInt(a.lot_number,10) - parseInt(b.lot_number, 10);
                }
                return 0;
            }) : []);
    }, [collections, isLoaded,customers, states] );

    useEffect(() => {
        if( id !== null && id !== '' ) {
            setSelectedCollection(collectionsWithRelations.find( collection => collection.id === parseInt(id)))
        }
    }, [ collectionsWithRelations, isLoaded, id ]);

    useEffect(() => {
        setLoading(true);
        dispatch(clearAssets());
        const fetchData = async() => {
            if (selectedCollection != null) {
                const collection = await getCollectionById(selectedCollection.id, auth.token);
                const updatedAssetTypes = await getAssetTypes(auth.token);
                const assetTypes = updatedAssetTypes.data

                dispatch(setAssets(collection.data.assets));

                // P1-2: the counts come from the server so this page, the scan
                // screen and the export can't disagree. The report used to
                // derive its own inventoryCollected/inventoryNotCollected pair
                // here while the tiles beside it showed a different partition.
                const canonicalStats = statsFromCollection(collection);
                setStats({
                    ...canonicalStats,
                    assetsCollected: statsByTypeName(canonicalStats, assetTypes)
                });
            }
            setLoading(false);
        };
        fetchData();
    }, [ selectedCollection, auth, dispatch ]);

    const downloadCsv = async () => {
        const customer = selectedCollection.customer;
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet1');

        worksheet.views = [{ showGridLines: false }];
        worksheet.getRow(1).height = 25;
        worksheet.getRow(2).height = 25;

        worksheet.mergeCells('A1', 'G1');
        worksheet.getCell('A1').value = customer.customer_name + ' Asset Collection Report';
        worksheet.getCell('A1').font = {name: 'Segoe UI', bold: true, size: 16.5};
        worksheet.getCell('A1').alignment = { horizontal: 'center', vertical: 'center',indent:0 };

        /* collection date */
        worksheet.getCell('A3').value = 'Collection Date ';

        let formattedDate ='';
        if(selectedCollection.scan_complete_date){
            const date = new Date(selectedCollection.scan_complete_date);
            formattedDate = new Intl.DateTimeFormat('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            }).format(date);
        }


        worksheet.getCell('B3').value = formattedDate;
        //lot number
        worksheet.getCell('C3').value = 'Lot #: '+ selectedCollection.lot_number;

        worksheet.mergeCells('D3', 'F3');
        worksheet.getCell('D3').value = '(Serialized / Non-Serialized Assets)';

        // P1-2: these four are the canonical counts from the server — the same
        // figures the tiles show. "On Inventory" means on the intent list, i.e.
        // excluding unexpected assets.
        worksheet.mergeCells('D4', 'E4');
        worksheet.getCell('D4').value = 'Total Assets On Inventory:';
        worksheet.getCell('F4').value = '('+stats.expected+' / 0)' ;

        worksheet.mergeCells('D5', 'E5');
        worksheet.getCell('D5').value = 'Assets Collected On Inventory:';
        worksheet.getCell('F5').value = '('+stats.matched+' / 0)' ;

        worksheet.mergeCells('D6', 'E6');
        worksheet.getCell('D6').value = 'Assets Not Collected On Inventory:';
        worksheet.getCell('F6').value = '('+stats.unscanned+' / 0)';

        worksheet.mergeCells('D7', 'E7');
        worksheet.getCell('D7').value = 'Total Assets Collected:';
        worksheet.getCell('F7').value = stats.totalScanned;

        var c = 8;
        Object.entries(stats.assetsCollected || {}).forEach(([asset, count]) => {
            worksheet.mergeCells(`D${c}:E${c}`);
            worksheet.getCell(`D${c}`).value = asset+':';
            worksheet.getCell(`F${c}`).value = count;
            worksheet.getCell(`D${c}`).font = {name: 'Segoe UI', bold: true, size: 11};
            worksheet.getCell(`D${c}`).alignment = { horizontal: 'right', vertical: 'center',indent:0 };
            worksheet.getCell(`F${c}`).font = {name: 'Segoe UI', bold: true, size: 11};
            worksheet.getCell(`F${c}`).alignment = { horizontal: 'right', vertical: 'center',indent:0 };
            c++;
        });

        //address
        worksheet.getCell('A4').value = 'Customer';
        worksheet.getCell('B4').value = customer.customer_name || '';
        worksheet.getCell('B5').value = customer.contact_name || '';
        worksheet.getCell('B6').value = customer.address1 || '';

        let city = customer.city || '';
        let stateCode = selectedCollection.state?.code || '';
        let zipCode = customer.zip_code || '';
        worksheet.getCell('B7').value = `${city} ${stateCode} ${zipCode}`.trim();


        const cells_left = ['A3', 'B3', 'C3','A4','B4','B5','B6','B7'];
        cells_left.forEach((cellRef) => {
            const cell = worksheet.getCell(cellRef);
            cell.font = {name:'Segoe UI', bold: true, size: 11};
            cell.alignment = { horizontal: 'left', vertical: 'center' };
        });

        const  cells_right = ['D3','D4','D5','D6','D7','F4','F5','F6','F7'];
        cells_right.forEach((cellRef) => {
            const cell = worksheet.getCell(cellRef);
            cell.font = {name:'Segoe UI', bold: true, size: 11};
            cell.alignment = { horizontal: 'right', vertical: 'center' };
        });

        //do the data below phew fowta

        let lineCount = (stats.assetsCollected ? Object.keys(stats.assetsCollected).length : 0) + 8;
      //need mo ung total dito ha

        // P1-2: the header totals above come from the server stats, the body
        // sections below from the redux assets slice. They are the same rows and
        // the same partition (a null collected/unexpected stringifies to 'No',
        // which is how the canonical counts treat it), so any mismatch means the
        // slice is stale — say so rather than emitting a self-contradicting report.
        const bodyMatched = assetsWithRelations.filter(a => a.collected === 'Yes' && a.unexpected === 'No').length;
        const bodyUnexpectedCollected = assetsWithRelations.filter(a => a.collected === 'Yes' && a.unexpected === 'Yes').length;
        const bodyUnscanned = assetsWithRelations.filter(a => a.collected === 'No' && a.unexpected === 'No').length;
        if (bodyMatched !== stats.matched || bodyUnscanned !== stats.unscanned
            || (bodyMatched + bodyUnexpectedCollected) !== stats.totalScanned) {
            console.warn('Report body counts disagree with the collection stats.',
                { stats, bodyMatched, bodyUnscanned, bodyUnexpectedCollected });
        }

        // P1-12: Item # was `asset.id` -- the global database primary key -- which is
        // why the client read the column as "the total number of assets in the
        // program". It is now the row's position in the intent list, and the sections
        // are sorted by it (they previously had no sort at all, so rows appeared in
        // whatever order the redux slice happened to hold). Scan UID carries the true
        // scan order alongside it.
        const itemNumbers = displayItemNumbers(assetsWithRelations);
        const sortByItem = byItemNumber(itemNumbers);

        const assetsCollectedSerialized = assetsWithRelations
            .filter(asset => asset.collected === 'Yes' && asset.unexpected === 'No')
            .sort(sortByItem)
            .map(asset => {
                return {
                    'Asset Type': asset.assetType != null ? asset.assetType.name : '',
                    'Asset Description': asset.description,
                    'Asset Tag': asset.asset_tag,
                    'Serial #': asset.serial_number,
                    'Notes': asset.collection_notes,
                    'Item #': itemNumbers.get(asset.id),
                    'Scan UID': asset.scan_uid || ''
                }
            });

      if(assetsCollectedSerialized.length > 0){
          const assetsCollectedSerializedCount = assetsCollectedSerialized.length;
          const assetsCollectedSerializedMapped = [
              [],
              ['ASSETS COLLECTED: On Serialized Inventory = ' + assetsCollectedSerializedCount],
              [],
              ['Asset Type', 'Asset Description', 'Asset Tag','Serial #','Notes','Item #','Scan UID'],
              ...assetsCollectedSerialized.map(d => [d['Asset Type'],
                                                     d['Asset Description'],
                                                     d['Asset Tag'],
                                                     d['Serial #'],
                                                     d['Notes'],
                                                     d['Item #'],
                                                     d['Scan UID']])
            ];

          let rowNumber = 1;
          assetsCollectedSerializedMapped.forEach((rowData) => {
              let row = worksheet.addRow(rowData);
              if(rowNumber==2){
                  var rowNumber_ =  lineCount + 1;
                  worksheet.mergeCells(`A${rowNumber_}:G${rowNumber_}`);
                  worksheet.getCell(rowNumber_, 1).font = {name:'Segoe UI', bold: true, size: 11 };
                  worksheet.getCell(rowNumber_, 1).alignment = { horizontal: 'left', vertical: 'center' };

              }else if(rowNumber == 4){
                  row.eachCell((cell, colNumber) => {
                      const borderStyle = { style: 'thin', color: { argb: 'FF000000' } };
                      cell.font = { name:'Segoe UI', bold: true, size:11,  color: { argb: '00000000' } };
                      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFC0FF3E' } };
                      cell.alignment = { horizontal: 'center', vertical: 'center' };
                      cell.border = {top: borderStyle, left: borderStyle, bottom: borderStyle, right: borderStyle
                      };
                  });
              }else{
                  row.eachCell((cell, colNumber) => {
                      cell.font = { name: 'Segoe UI', size: 11 };
                      cell.alignment = {
                          horizontal: colNumber === row.cellCount ? 'center' : 'left',
                          vertical: 'center'
                      };
                  });
              }
              rowNumber++;
          });
          lineCount = lineCount + assetsCollectedSerializedCount + 3; //kaya 3 kasi ung dalawang blank at ung isang thead
        }

        ///start collected not serialized

        const assetsCollectedNotSerialized = assetsWithRelations
            .filter(asset => asset.collected === 'Yes' && asset.unexpected === 'Yes')
            .sort(sortByItem)
            .map(asset => {
                return {
                    'Asset Type': asset.assetType != null ? asset.assetType.name : '',
                    'Asset Description': asset.description,
                    'Asset Tag': asset.asset_tag,
                    'Serial #': asset.serial_number,
                    'Notes': asset.collection_notes,
                    'Item #': itemNumbers.get(asset.id),
                    'Scan UID': asset.scan_uid || ''
                }
            });

      if(assetsCollectedNotSerialized.length > 0){
          const assetsCollectedNotSerializedCount = assetsCollectedNotSerialized.length;
          const assetsCollectedNotSerializedMapped = [
              [],
              ['ASSETS COLLECTED: Not On Serialized Inventory = ' + assetsCollectedNotSerializedCount],
              [],
              ['Asset Type', 'Asset Description', 'Asset Tag','Serial #','Notes','Item #','Scan UID'],
              ...assetsCollectedNotSerialized.map(d => [d['Asset Type'],
                  d['Asset Description'],
                  d['Asset Tag'],
                  d['Serial #'],
                  d['Notes'],
                  d['Item #'],
                  d['Scan UID']])
          ];

          let rowNumber = 1;
          assetsCollectedNotSerializedMapped.forEach((rowData) => {
              let row = worksheet.addRow(rowData);
              if(rowNumber==2){
                  var rowNumber_ =  lineCount + 2;
                  worksheet.mergeCells(`A${rowNumber_}:G${rowNumber_}`);
                  worksheet.getCell(rowNumber_, 1).font = {name:'Segoe UI', bold: true, size: 11 };
                  worksheet.getCell(rowNumber_, 1).alignment = { horizontal: 'left', vertical: 'center' };

              }else if(rowNumber == 4){
                  row.eachCell((cell, colNumber) => {
                      const borderStyle = { style: 'thin', color: { argb: 'FF000000' } };
                      cell.font = { name:'Segoe UI', bold: true, size:11,  color: { argb: '00000000' } };
                      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFE9E2A' } };
                      cell.alignment = { horizontal: 'center', vertical: 'center' };
                      cell.border = {top: borderStyle, left: borderStyle, bottom: borderStyle, right: borderStyle
                      };
                  });
              }else{

                  row.eachCell((cell, colNumber) => {
                      cell.font = { name: 'Segoe UI', size: 11 };
                      cell.alignment = {
                          horizontal: colNumber === row.cellCount ? 'center' : 'left',
                          vertical: 'center'
                      };
                  });

              }
              rowNumber++;
          });

          lineCount = lineCount + assetsCollectedNotSerializedCount + 4;

      }

      ///start uncollected not serialized
      const assetsUnCollectedSerialized = assetsWithRelations
            .filter(asset => asset.collected === 'No' && asset.unexpected === 'No')
            .sort(sortByItem)
            .map(asset => {
                return {
                    'Asset Type': asset.assetType != null ? asset.assetType.name : '',
                    'Asset Description': asset.description,
                    'Asset Tag': asset.asset_tag,
                    'Serial #': asset.serial_number,
                    'Notes': asset.collection_notes,
                    'Item #': itemNumbers.get(asset.id),
                    // Nothing was scanned in this section by definition, so Scan UID is
                    // blank. The column stays for a consistent row shape.
                    'Scan UID': asset.scan_uid || ''
                }
            });

      if(assetsUnCollectedSerialized.length > 0){
          const assetsUnCollectedSerializedCount = assetsUnCollectedSerialized.length;
          const assetsUnCollectedSerializedMapped = [
              [],
              ['ASSETS NOT COLLECTED: On Serialized Inventory = ' + assetsUnCollectedSerializedCount],
              [],
              ['Asset Type', 'Asset Description', 'Asset Tag','Serial #','Notes','Item #','Scan UID'],
              ...assetsUnCollectedSerialized.map(d => [d['Asset Type'],
                  d['Asset Description'],
                  d['Asset Tag'],
                  d['Serial #'],
                  d['Notes'],
                  d['Item #'],
                  d['Scan UID']]),
              [],
              []
          ];


          let rowNumber = 1;
          assetsUnCollectedSerializedMapped.forEach((rowData) => {
              let row = worksheet.addRow(rowData);
              if(rowNumber==2){
                  var rowNumber_ =  lineCount + 2;
                  worksheet.mergeCells(`A${rowNumber_}:G${rowNumber_}`);
                  worksheet.getCell(rowNumber_, 1).font = {name:'Segoe UI', bold: true, size: 11 };
                  worksheet.getCell(rowNumber_, 1).alignment = { horizontal: 'left', vertical: 'center' };

              }else if(rowNumber == 4){
                  row.eachCell((cell, colNumber) => {
                      const borderStyle = { style: 'thin', color: { argb: 'FF000000' } };
                      cell.font = { name:'Segoe UI', bold: true, size:11,  color: { argb: '00000000' } };
                      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFDB3723' } };
                      cell.alignment = { horizontal: 'center', vertical: 'center' };
                      cell.border = {top: borderStyle, left: borderStyle, bottom: borderStyle, right: borderStyle
                      };
                  });
              }else{
                  row.eachCell((cell, colNumber) => {
                      cell.font = { name: 'Segoe UI', size: 11 };
                      cell.alignment = {
                          horizontal: colNumber === row.cellCount ? 'center' : 'left',
                          vertical: 'center'
                      };
                  });

              }
              rowNumber++;
          });



      }

        worksheet.columns = [
            { width: 30 },
            { width: 30 },
            { width: 30 },
            { width: 30 },
            { width: 15 },
            { width: 15 },
            // P1-12: Scan UID. Wide enough for {lot}-{YYYYMMDDTHHmmss}-{nnn} unwrapped.
            { width: 30 }
        ];


        // Generate Excel file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        // Download the file
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        const filename = selectedCollection.lot_number + ' ' + customer.customer_name;

        const cleanFilename = filename
            .replace(/[^a-zA-Z0-9\s]/g, '')
            .replace(/\s+/g, '_')
            .concat('_asset_collection_report.xlsx');

        link.href = url;
        link.download = cleanFilename;
        link.click();
        window.URL.revokeObjectURL(url);
    };



    /*
    const assetsWithRelations = assets
        .map( asset => Object.assign({}, asset, {
            collection: collectionsWithRelations.find( collection => collection.id === asset.collection_id),
            assetType: assetTypes.find( assetType => assetType.id === asset.asset_type_id),
        } ));

     */

    const assetsWithRelations = assets
        .map(asset => Object.assign({}, asset, {
            collection: collectionsWithRelations.find(collection => collection.id === asset.collection_id),
            assetType: assetTypes.find(assetType => assetType.id === asset.asset_type_id),
            collected: asset.collected ? "Yes" : "No",
            unexpected: asset.unexpected ? "Yes" : "No",
        }));

    const collectionInProgress = selectedCollection == null || selectedCollection.end_time == null || selectedCollection.end_time === '' ;
    const selectedCollectionId = selectedCollection == null ? '' : selectedCollection.id;

    return (
        <Box sx={{ height: '100vh', width: '100%' }}>
            <div style={{marginTop: 10, marginBottom:15}}>
                <FormControl variant="outlined">
                    <InputLabel htmlFor="collection-select">Collection</InputLabel>
                    <Select
                        disabled={loading}
                        style={{marginRight: 10, width: 450}}
                        id="collection-select"
                        value={selectedCollectionId}
                        label="Collection"
                        onChange={(e) => {
                            const selected = collectionsWithRelations.find(cwr => cwr.id === e.target.value);
                            setSelectedCollection(selected);
                            //console.log(selected); // Log the selected value directly
                        }}

                    >
                        {collectionsWithRelations.map(c => <MenuItem key={c.id} value={c.id}>{c.lot_number} - {c.customer.customer_name} - {(c.start_time || "").slice(0,10)}</MenuItem>)}
                    </Select>
                </FormControl>
            </div>



            {selectedCollection != null ? (

                <div id="the-collection" className="d-flex">
                    <div className="lefty" style={{width: '60%'}}>

                        <div className="d-flex">
                            <div>
                                <h2>ORDER# {selectedCollection.lot_number}</h2>

                                <div className="date">
                                {selectedCollection.scan_complete === true ? (
                                        <>
                                            {selectedCollection.start_time?.slice(0, 10)} - {selectedCollection.scan_complete_date?.slice(0, 10)}
                                            <span>SCAN COMPLETED</span>
                                        </>
                                    ) : (
                                        <>
                                        {selectedCollection.start_time?.slice(0, 10)} - {collectionInProgress ? 'In Progress' : selectedCollection.end_time?.slice(0, 10)}
                                        </>
                                    )}
                                </div>

                            </div>
                        </div>
                        <div className="d-flex w-100" style={{gap:'15px'}}>
                            <div className="col-4">
                                <h3>{selectedCollection.customer.customer_name || ''}</h3>
                                <address>
                                    {selectedCollection.customer.address1 || ''}<br/>
                                    {(selectedCollection.customer.address2 != null && selectedCollection.customer.address2.trim() !== '') ?
                                        <>{`${selectedCollection.customer.address2}`}<br/></> : null}
                                    {formatCityStateZip(selectedCollection.customer.city, selectedCollection.state?.code, selectedCollection.customer.zip_code)}<br/>
                                </address>
                                    <Button style={{margin: 10, marginLeft:0}} variant="contained" color="primary" disabled={selectedCollection == null} onClick={() => downloadCsv()}>Export XLS</Button>


                            </div>
                            <div className="col-4">
                                <h4>Onsite Contact 1:</h4>
                                <address>
                                    {selectedCollection.customer.contact_name}<br/>
                                    {selectedCollection.customer.email_address}<br/>
                                    {selectedCollection.customer.phone_number}
                                </address>
                            </div>
                            <div className="col-4">
                                <h4>Onsite Contact 2</h4>
                                <address>{selectedCollection.customer.contact_name2}<br/>
                                    {selectedCollection.customer.email_address2}<br/>
                                    {selectedCollection.customer.phone_number2}</address>

                            </div>
                        </div>

                    </div>


                    <div className="righty" style={{width: '40%', position: 'relative'}}>

                        <div className="d-flex" style={{width: '100%', justifyContent: "end", display: "flex"}}>
                            <div className="boxed-content-stats">
                                <h2>{stats.expected}</h2>
                                <p><strong>Expected</strong> <br/>Asset Count</p>
                            </div>
                            <div className="boxed-content-stats">
                                <h2>{stats.matched}</h2>
                                <p><strong>Matched</strong> <br/> Asset Count</p>
                            </div>

                            <div className="boxed-content-stats">
                                <h2>{stats.unscanned}</h2>
                                <p><strong>Unscanned</strong> <br/>Asset Count</p>
                            </div>

                            <div className="boxed-content-stats">
                                <h2>{stats.unexpected} </h2>
                                <p><strong>Unexpected</strong> <br/>Asset Count</p>
                            </div>
                        </div>

                        <div id="collected-assets">
                            <ul>
                                {stats && stats.assetsCollected ? (
                                    Object.entries(stats.assetsCollected).map(([asset, count]) => (
                                        <li key={asset}>
                                            {asset} <span>{count}</span>
                                        </li>
                                    ))
                                ) : null}

                            </ul>
                        </div>
                    </div>

                </div>) : null}


            <StripedDataGrid
                slots={{toolbar: GridToolbar}}
                getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                }
                rows={assetsWithRelations}
                columns={columns}
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 20,
                        },
                    },
                }}
                density="compact"
                pageSizeOptions={pageSizeOptions}
                disableRowSelectionOnClick

            />
            {!isLoaded ? (
                <div style={{position: "fixed", top: 0, bottom: 0, left: 0, right: 0, backgroundColor: "#00000022", display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <div className="lds-roller">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            ) : null}
        </Box>



    )
}

export default CollectionReports;

